import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {PipelineStepDataFragment as PipelineStepDataFragmentType} from './__generated/PipelineStepDataFragment';

export const PIPELINE_STEP_DATA_FRAGMENT = gql`
  fragment PipelineStepDataFragment on PipelineStepDataDomainNode {
    id
    name
    rawDatas {
      ... on DataFrameDomainNode {
        id
        name
        columns {
          systemName
          displayName
          type
        }
      }
      ... on ChartNode {
        id
        name
        library
        libraryConfig
        libraryVersion
        rasterDownloadUrl
        rasterExternalFileId
      }
      ... on ScratchFileNode {
        ...ScratchFileGraphQL
      }
    }
  }

  ${getFragmentWrapper('ScratchFile').fragment}
`;

export const PipelineStepDataFragment: FragmentWrapper<PipelineStepDataFragmentType> = {
  fragment: PIPELINE_STEP_DATA_FRAGMENT,
  fragmentName: 'PipelineStepDataFragment',
};
